module.exports = "/images/lachiever-logo.svg";